import * as React from "react"

function ButtonArrowSVG(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 490.693 490.693" width={512} height={512} {...props}>
      <path
        d="M48.032 1.443C42.937-1.514 36.409.219 33.452 5.314a10.66 10.66 0 00-1.441 5.367v469.333a10.67 10.67 0 0016.022 9.238l405.333-234.667c5.096-2.956 6.83-9.483 3.874-14.579a10.668 10.668 0 00-3.874-3.874L48.032 1.443z"
        className="prefix__active-path"
      />
    </svg>
  )
}

export default ButtonArrowSVG
